//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').service('EcommerceIntegrationsService', [
    '$interval',
    '$log',
    'EcommerceIntegrationsActions',
    'EcommerceIntegratonsAddCatalogStatus',
    'EcommerceIntegrationsApiService',
    'EcommerceIntegrationsAsyncStatusState',
    'EcommerceIntegrationsOptions',
    'EcommerceIntegrationsView',
    'ProductFeedHealthAcquisitionStatuses',
    'rx',
    'SessionVarsService',
    function(
            $interval,
            $log,
            EcommerceIntegrationsActions,
            EcommerceIntegratonsAddCatalogStatus,
            EcommerceIntegrationsApiService,
            EcommerceIntegrationsAsyncStatusState,
            EcommerceIntegrationsOptions,
            EcommerceIntegrationsView,
            ProductFeedHealthAcquisitionStatuses,
            rx,
            SessionVarsService,
        ) {
      const defaultProgressValue = 'indeterminate';
      const TEN_SECONDS_IN_MILLIS = 10 * 1000;

      this.queryingInterval = undefined;

      const initialStore = {
        connectingState: EcommerceIntegrationsAsyncStatusState.NOT_CONNECTING,
        integration: undefined,
        view: EcommerceIntegrationsView.START,
        catalogId: null,
        progress: defaultProgressValue,
      };

            // These key map to the value of `EcommerceIntegrationsAsyncStatusState`
      const progressValues = {
        succeeded: 1,
        failed_ingestion: -1,
        failed_token: -1,
        connecting: 'indeterminate',
        not_connecting: 'indeterminate',
        more_than_one: 1,
      };

            /**
             * RxJS subjects.
             */
      const dispatcher = new rx.BehaviorSubject({});

      const determineIntegration = () => {
        const isMagentoEnabled = SessionVarsService.isFeatureEnabled(EcommerceIntegrationsOptions.MAGENTO);
        const isShopifyEnabled = SessionVarsService.isFeatureEnabled(EcommerceIntegrationsOptions.SHOPIFY);

        if (isMagentoEnabled) {
          return EcommerceIntegrationsOptions.MAGENTO;
        } else if (isShopifyEnabled) {
          return EcommerceIntegrationsOptions.SHOPIFY;
        }
        $log.error('Client did not have a feature flag for an ecom platform, yet EcommerceIntegrationsService was initialized.');
        return undefined;
      };

      const changeConnectingState = (newConnectingState) => {
        dispatcher.next({
          type: EcommerceIntegrationsActions.CHANGE_CONNECTING_STATE,
          connectingState: newConnectingState,
          progress: progressValues[newConnectingState],
        });
      };

      const changeView = (newView) => {
        dispatcher.next({
          type: EcommerceIntegrationsActions.CHANGE_VIEW,
          view: newView,
        });
      };

      const clearInterval = (interval) => {
        $interval.cancel(interval);
      };

      const connectingAsyncFinished = () => {
        clearInterval(this.queryingInterval);
      };

      const changeConnectingStateToFailedIngestion = () => {
        connectingAsyncFinished();
        changeConnectingState(EcommerceIntegrationsAsyncStatusState.FAILED_INGESTION);
      };

      const changeConnectingStateToSucceeded = () => {
        connectingAsyncFinished();
        changeConnectingState(EcommerceIntegrationsAsyncStatusState.SUCCEEDED);
      };

      const getAcquisitionAndSetConnectingState = (catalogId) => {
        rx.Observable.fromPromise(EcommerceIntegrationsApiService.getFirstCatalogAcquisition(catalogId))
                    .subscribe((response) => {
                      if (response.acquisitionStatus) {
                        switch (response.acquisitionStatus) {
                          case ProductFeedHealthAcquisitionStatuses.SUCCESSFUL:
                          case ProductFeedHealthAcquisitionStatuses.MORE_THAN_ONE:
                                    // Shouldn't hit `MORE_THAN_ONE`, but when it does, default to showing Catalog Health Page
                            changeConnectingStateToSucceeded();
                            break;
                          case ProductFeedHealthAcquisitionStatuses.FAILURE:
                            changeConnectingStateToFailedIngestion();
                            break;
                          case ProductFeedHealthAcquisitionStatuses.EMPTY:
                          case ProductFeedHealthAcquisitionStatuses.PENDING:
                          default:
                                    // Do nothing! This is the connecting state
                            break;
                        }
                      }
                    });
      };

      const startQueryingIntervalForCatalogAcquisition = (catalogId) => {
        this.queryingInterval = $interval(() => getAcquisitionAndSetConnectingState(catalogId), TEN_SECONDS_IN_MILLIS);
      };

      const changeConnectingStateToConnecting = () => {
        changeConnectingState(EcommerceIntegrationsAsyncStatusState.CONNECTING);
      };

            // Actions to initialize integration
      const initializeIntegration = () => {
        const integration = determineIntegration();
        dispatcher.next({
          type: EcommerceIntegrationsActions.INITIALIZE_INTEGRATION_TYPE,
          integration,
        });
      };

      this.store = new rx.BehaviorSubject(initialStore);

            /**
             * Reducer
             */
      dispatcher.scan((state, action) => {
        const newState = angular.copy(state);
        switch (action.type) {
          case EcommerceIntegrationsActions.SET_CATALOG_ID:
            newState.catalogId = action.catalogId;
            break;
          case EcommerceIntegrationsActions.INITIALIZE_INTEGRATION_TYPE:
            newState.integration = action.integration;
            break;
          case EcommerceIntegrationsActions.CHANGE_VIEW:
            newState.view = action.view;
            break;
          case EcommerceIntegrationsActions.CHANGE_CONNECTING_STATE:
            newState.connectingState = action.connectingState;
            newState.progress = action.progress;
            break;
          default:
            $log.error(`unrecognized action type: ${action.type}`);
            break;
        }
        return newState;
      }).subscribe((newState) => {
        this.store.next(newState);
      });

            // Change Ecommerce Integration View Action Handlers
      this.changeViewToConfiguringForm = () => {
        changeView(EcommerceIntegrationsView.CONFIGURING_FORM);
      };

      this.changeViewToStart = () => {
        changeView(EcommerceIntegrationsView.START);
      };

      this.changeViewToConnecting = () => {
        changeView(EcommerceIntegrationsView.CONNECTING_ASYNC);
        changeConnectingStateToConnecting();
      };

      this.changeViewToConnected = () => {
        changeView(EcommerceIntegrationsView.CONNECTED);
      };

            // TODO implement this with the form https://curalate.atlassian.net/browse/DEV-28092
            // function changeConnectingStateToFailedToken() {
            //     changeConnectingState(EcommerceIntegrationsAsyncStatusState.FAILED_TOKEN);
            // }

      this.createMagentoCatalog = (magentoFeedUrl, magentoAccessToken, locale) => {
        magentoFeedUrl = magentoFeedUrl.trim();
        magentoAccessToken = magentoAccessToken.trim();
        locale = locale.trim();
        rx.Observable.fromPromise(EcommerceIntegrationsApiService.createMagentoCatalog(magentoFeedUrl, magentoAccessToken, locale))
                    .subscribe((response) => {
                      this.handleCatalogCreatedResponse(response);
                    });
      };

      this.createShopifyCatalog = (shopifyAccountName, shopifyApiKey, shopifyAccessToken, storefrontAccessToken, locale) => {
        rx.Observable.fromPromise(EcommerceIntegrationsApiService.createShopifyCatalog(
                    shopifyAccountName,
                    shopifyApiKey,
                    shopifyAccessToken,
                    storefrontAccessToken,
                    locale,
                )).subscribe((response) => {
                  this.handleCatalogCreatedResponse(response);
                });
      };

      this.validateMagentoTokens = (magentoStoreUrl, magentoAccessToken) => {
        return EcommerceIntegrationsApiService.validateMagentoTokens(magentoStoreUrl, magentoAccessToken);
      };

      this.validateShopifyTokens = (shopifyAccountName, shopifyApiKey, shopifyAccessToken, storefrontAccessToken) => {
        return EcommerceIntegrationsApiService.validateShopifyTokens(
                    shopifyAccountName,
                    shopifyApiKey,
                    shopifyAccessToken,
                    storefrontAccessToken,
                );
      };

      this.changeConnectingStateToPollingForAcquisitions = (catalogId) => {
        startQueryingIntervalForCatalogAcquisition(catalogId);
      };

      this.handleCatalogCreatedResponse = (response) => {
        switch (response.setupStatus) {
          case EcommerceIntegratonsAddCatalogStatus.SUCCESSFUL_SETUP:
            this.changeConnectingStateToPollingForAcquisitions(response.catalogId);
            break;
          case EcommerceIntegratonsAddCatalogStatus.FAILURE_BAD_TOKEN:
          case EcommerceIntegratonsAddCatalogStatus.FAILURE_CATALOG_ADD:
          case EcommerceIntegratonsAddCatalogStatus.FAILURE_CLIENT_NOT_FOUND:
          case EcommerceIntegratonsAddCatalogStatus.FAILURE_TOKEN_TIMEOUT:
          default:
            changeConnectingStateToFailedIngestion();
            break;
        }
      };

      this.getFirstCatalogAcquisition = function(catalogId) {
        return rx.Observable.fromPromise(EcommerceIntegrationsApiService.getFirstCatalogAcquisition(catalogId));
      };

      this.setCatalogId = (catalogId) => {
        dispatcher.next({
          type: EcommerceIntegrationsActions.SET_CATALOG_ID,
          catalogId,
        });
      };

      this.initialize = function() {
        initializeIntegration();
        this.changeViewToStart();
      };
    }]);
})();
